const themeStyles = colors => {
  const styles = {
    button: {
      margin: 'auto',
      marginTop: '1rem',
      display: 'block',
      textTransform: 'uppercase',
      backgroundColor: colors.primary,
      color: colors.textWhite,
      borderRadius: 25,
      border: 'none',
      fontWeight: 'bold'
    }
  }
  return styles
}

export default themeStyles
